import { HelpHubSection, Language } from '@instaclause-webapp/shared-core';

export const HELP_HUB_DOCUMENT_OFFERING_URLS: Partial<Record<Language, string>> = {
  nl: 'https://publish.obsidian.md/kb-instaclause-nl/Documentoverzicht/Overzicht%20beschikbare%20documenten%20(Nederland)',
  'be-nl':
    'https://instaclause-be-nl.notion.site/Overzicht-actueel-aanbod-documenten-368820915c8881459b05e07adebd4652',
  fr: 'https://instaclause-be-fr.notion.site/Aper-u-de-l-offre-actuelle-de-documents-0cc820915c8882c6b82d812279812fa1',
  en: 'https://instaclause-en.notion.site/Overview-of-available-documents-Belgium-e46820915c88825facdb81629a2d0faf?pvs=74',
};

export const HELP_HUB_GETTING_STARTED_URLS: Partial<Record<Language, string>> = {
  nl: 'https://publish.obsidian.md/kb-instaclause-nl/nl/contract-composer/getting-started',
  'be-nl':
    'https://instaclause-be-nl.notion.site/Instaclause-Knowledge-base-368820915c88808da8d6d7afac4f1de6',
  fr: 'https://instaclause-be-fr.notion.site/Instaclause-Knowledge-base-390820915c8881b4ac50ceae66b6bc8d',
  en: 'https://instaclause-en.notion.site/?v=ffd820915c88827ab56c082fc52259c4',
};

export const HELP_HUB_HELP_ARTICLE_URLS: Partial<Record<Language, string>> = {
  nl: 'https://publish.obsidian.md/kb-instaclause-nl/nl',
  'be-nl': 'https://instaclause-be-nl.notion.site/?v=351820915c888095bacb000c50fbc6b4&pvs=25',
  fr: 'https://instaclause-be-fr.notion.site/?v=8d8820915c8882cc8bf588c92ba0ba88',
  en: 'https://instaclause-en.notion.site/?v=ffd820915c88827ab56c082fc52259c4',
};

export const HELP_HUB_PRIVACY_SECURITY_URLS: Partial<Record<Language, string>> = {
  nl: 'https://instaclause.com/nl/privacy-en-cookiebeleid',
  'be-nl': 'https://instaclause.com/be-nl/privacy-en-cookiebeleid',
  fr: 'https://instaclause.com/be-fr/politique-de-confidentialite-et-de-cookies',
  en: 'https://instaclause.com/be-nl/privacy-en-cookiebeleid',
};

export const ACCOUNTANT_HELP_HUB_SECTIONS: HelpHubSection[] = [
  {
    id: 'learn',
    titleKey: 'HELP_HUB.SECTIONS.LEARN',
    items: [
      {
        id: 'document-offering',
        icon: 'file-text',
        titleKey: 'HELP_HUB.ITEMS.DOCUMENT_OFFERING.TITLE',
        descriptionKey: 'HELP_HUB.ITEMS.DOCUMENT_OFFERING.DESCRIPTION',
        action: 'external',
        url: HELP_HUB_DOCUMENT_OFFERING_URLS.nl,
        localizedUrls: HELP_HUB_DOCUMENT_OFFERING_URLS,
      },
      {
        id: 'getting-started',
        icon: 'edit',
        titleKey: 'HELP_HUB.ITEMS.GETTING_STARTED.TITLE',
        descriptionKey: 'HELP_HUB.ITEMS.GETTING_STARTED.DESCRIPTION',
        action: 'external',
        url: HELP_HUB_GETTING_STARTED_URLS.nl,
        localizedUrls: HELP_HUB_GETTING_STARTED_URLS,
      },
      {
        id: 'help-articles',
        icon: 'help',
        titleKey: 'HELP_HUB.ITEMS.HELP_ARTICLES.TITLE',
        descriptionKey: 'HELP_HUB.ITEMS.HELP_ARTICLES.DESCRIPTION',
        action: 'external',
        url: HELP_HUB_HELP_ARTICLE_URLS.nl,
        localizedUrls: HELP_HUB_HELP_ARTICLE_URLS,
      },
    ],
  },
  {
    id: 'trust',
    titleKey: 'HELP_HUB.SECTIONS.TRUST',
    items: [
      {
        id: 'privacy-security',
        icon: 'shield',
        titleKey: 'HELP_HUB.ITEMS.PRIVACY_SECURITY.TITLE',
        descriptionKey: 'HELP_HUB.ITEMS.PRIVACY_SECURITY.DESCRIPTION',
        action: 'external',
        url: HELP_HUB_PRIVACY_SECURITY_URLS.nl,
        localizedUrls: HELP_HUB_PRIVACY_SECURITY_URLS,
      },
    ],
  },
  {
    id: 'need-help',
    titleKey: 'HELP_HUB.SECTIONS.NEED_HELP',
    items: [
      {
        id: 'contact-support',
        icon: 'message',
        titleKey: 'HELP_HUB.ITEMS.CONTACT_SUPPORT.TITLE',
        descriptionKey: 'HELP_HUB.ITEMS.CONTACT_SUPPORT.DESCRIPTION',
        // TODO(INS-2269): switch back to 'internal' to re-enable the in-app contact form
        // once SupportService is wired to the backend.
        action: 'mailto',
        url: 'mailto:support@instaclause.com',
      },
      {
        id: 'system-status',
        icon: 'activity',
        titleKey: 'HELP_HUB.ITEMS.SYSTEM_STATUS.TITLE',
        descriptionKey: 'HELP_HUB.ITEMS.SYSTEM_STATUS.DESCRIPTION',
        action: 'external',
        url: 'https://instaclause.betteruptime.com',
      },
    ],
  },
];
